var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.idx)?_c('div',{attrs:{"id":"base-delete-button-vuex"}},[(_vm.permissionDelete)?_c('v-btn',{attrs:{"color":"red","dark":""},on:{"click":function($event){_vm.doDelete(_vm.idx)}}},[_vm._t("default",[_vm._v("Delete")])],2):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c198daa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseDeleteButtonVuex.vue
// module id = null
// module chunks = 